const INDEX_ITEMS = [
  { id: 1, name: '香蕉视频热播榜', count: '128部', icon: 'ri-fire-line', color: 'text-primary-600 bg-primary-100' },
  { id: 2, name: '糖豆视频新剧速递', count: '96部', icon: 'ri-rocket-line', color: 'text-accent-600 bg-accent-100' },
  { id: 3, name: '小蓝视频经典重温', count: '203部', icon: 'ri-refresh-line', color: 'text-secondary-600 bg-secondary-100' },
  { id: 4, name: '蓝莓视频口碑佳作', count: '87部', icon: 'ri-trophy-line', color: 'text-primary-600 bg-primary-100' },
  { id: 5, name: '都市情感剧集库', count: '156部', icon: 'ri-heart-2-line', color: 'text-accent-600 bg-accent-100' },
  { id: 6, name: '悬疑烧脑专题区', count: '74部', icon: 'ri-magic-line', color: 'text-secondary-600 bg-secondary-100' },
  { id: 7, name: '古装历史大剧场', count: '112部', icon: 'ri-ancient-gate-line', color: 'text-primary-600 bg-primary-100' },
  { id: 8, name: '高分电影精选集', count: '189部', icon: 'ri-movie-2-line', color: 'text-accent-600 bg-accent-100' },
  { id: 9, name: '不缓冲高清专区', count: '245部', icon: 'ri-4k-line', color: 'text-secondary-600 bg-secondary-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/70 text-secondary-700 text-xs font-medium mb-3">
            分类导航
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">影视索引</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            快速找到你想看的影视专题与分类合集
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.id}
              href="#media"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-background-300/80 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-11 h-11 md:w-12 md:h-12 rounded-xl ${item.color} flex items-center justify-center`}>
                <i className={`${item.icon} text-lg md:text-xl`}></i>
              </div>
              <div className="text-center">
                <div className="text-sm font-medium text-foreground-800 leading-snug">{item.name}</div>
                <div className="text-xs text-foreground-400 mt-1">{item.count}</div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href="#media"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer transition-colors"
          >
            查看全部影视资源
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}